import config from '@/config';
import { Mutations } from '@/util/settings/enums';
import { LocalStorageEnum } from './enums';
export const setAuthDataToLocalStorage = (response) => {
    localStorage.setItem(LocalStorageEnum.AUTH_EMAIL, response.idTokenClaims.AuthEmail);
};
export const setAuthDataToStore = (store, response) => {
    store.commit(Mutations.SET_AUTH_DATA, {
        authEmail: response.idTokenClaims.AuthEmail,
        doctorId: response.idTokenClaims.extension_doctorID || null,
        connectId: response.idTokenClaims.extension_connectID || null
    });
};
export const getAuthEmailFromLocalStorage = () => localStorage.getItem(LocalStorageEnum.AUTH_EMAIL);
export const clearAuthDataFromLocalStorage = () => {
    localStorage.removeItem(LocalStorageEnum.AUTH_EMAIL);
};
export const buildAuthority = (policy) => {
    const { azureAd: { instance } } = config;
    return `https://${instance}.b2clogin.com/tfp/${instance}.onmicrosoft.com/${policy}`;
};
